<div class="usan-form-item molecular-info-container">
  <div class="molecular-info-text">
    Enter the molecular formula using standard chemical notation:
    <span class="input-info">
      <a (click)="toggleExpandInfo()">View input format</a>
      <mat-icon (click)="toggleExpandInfo()">{{ isExpandInfo ? 'arrow_drop_up' :'arrow_drop_down' }}</mat-icon>
    </span>
  </div>
  <div class="molecular-info-text" [ngClass]="{ 'invisible' : !isExpandInfo }">
    <ul>
      <li>Use correct element symbols: capitalize the first letter and lowercase any subsequent letters (e.g. C for carbon, Cl for chlorine, Na for sodium)</li>
      <li>Use numbers as subscripts after each element to indicate quantity (e.g. H2O for water)
      <li>Do not use spaces between elements</li>
      <li>For complex formulas, use parentheses to group elements (e.g. Ca(OH)2)</li>
      <li>For salts, separate ions with a dot (e.g. NaCl.2H2O)</li>
      <li>No spaces between elements or ions</li>
    </ul>
  </div>
</div>
